import { useEffect, useMemo, useState } from 'react';
import { getSolutiontToProductId } from '../service/ApiServicioTecnico';

/**
 * Dada la solución hoja que viene en la URL, devuelve los ids de toda la cadena
 * de acordeones que hay que abrir.
 *
 * La URL solo lleva la hoja (".../verificar-bujia-28"). El endpoint de una
 * solución devuelve `nombres` con la cadena completa de ancestros ordenada de la
 * raíz a la hoja, así que no hace falta meter el camino entero en la URL ni
 * limitar la profundidad del árbol.
 */
export function useSolutionChain(productId, solutionId) {
    const [chain, setChain] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!productId || !solutionId) {
            setChain([]);
            return;
        }

        let cancelled = false;
        setLoading(true);

        getSolutiontToProductId(productId, solutionId)
            .then(response => {
                if (cancelled) return;
                const data = response?.data ?? response;
                setChain(Array.isArray(data?.nombres) ? data.nombres : []);
            })
            .catch(error => {
                if (cancelled) return;
                console.error('No se pudo resolver la cadena de la solución:', error);
                setChain([]);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => { cancelled = true; };
    }, [productId, solutionId]);

    // Memoizado para que la referencia sea estable: se pasa hacia abajo por todo
    // el árbol recursivo de acordeones.
    const openIds = useMemo(() => new Set(chain.map(item => item.id)), [chain]);

    return {
        chain,   // [{ id, name }] de la raíz a la hoja
        openIds,
        loading,
    };
}
